import * as React from 'react'

import { Hero } from './sections/Hero'
import { Join } from './sections/Join'
import { Makers } from './sections/Makers'

/**
 * Team page ("L'équipe") main content.
 *
 * Both server-rendered (prerender) and hydrated on the client, so it must stay pure: no
 * `window`/`document`/`localStorage`/`matchMedia` reads and no per-request/browser-only values.
 * The site header/footer are NOT part of this tree — they are mounted separately (see entry-client).
 * The "Makers" section also renders the mission band (they share one white section, as in the design).
 */
export function App(): React.ReactElement {
  return (
    <main>
      <Hero />
      <Makers />
      <Join />
    </main>
  )
}
